import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { GeographyProvider } from '../../shared/providers/geography.provider';
import { RegionProvider } from '../../shared/providers/region.provider';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  userFormGroup: FormGroup;
  submitted = false;

  user: any;
  profiles: any;
  geographeis: any;
  channels: any;
  cities: any;
  states: any;
  regions: any;
  roleUserList: any;
  selectedProfile: any;
  seletedGeograpghy: any;
  seletedChannel: any;
  seletedCity: any;
  seletedState: any;
  isAdminRole: boolean = false;
  isOutlet: boolean = false;
  isTSE: boolean = false;
  isDistributor: boolean = false;
  isMystry: boolean = false;
  isOthersUser: boolean = true;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastClientService,
    private route: ActivatedRoute,
    public regionProviders: RegionProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,

  ) { }

  ngOnInit() {

    this.route.params
      .subscribe(
        (params: Params) => {
          let userId = +params['userId'];
          console.log(userId);
          this.getUserDetails(userId)
        }
      );
    this.getUserProfiles();
    this.getGeographeis();
    this.getRegions();
    this.getChannelTypes();
    this.getCitieAndStates();


    this.userFormGroup = this.fb.group({
      controlProfile: new FormControl('', [Validators.required]),

      controlUserName: new FormControl(''),
      controlPassword: new FormControl(''),

      controlDistributor: new FormControl(''),
      controlTSE: new FormControl(''),


      controlChannel: new FormControl(''),
      controlMgrName: new FormControl(''),
      controlMgrPhone: new FormControl(''),
      controlLicense: new FormControl(''),

      controlEmpCode: new FormControl(''),
      controlEmail: new FormControl('', [Validators.required]),
      controlPhone: new FormControl('',[Validators.required,  Validators.pattern("^[0-9]*$"),Validators.minLength(10), Validators.maxLength(10)]),

      controlRoCode: new FormControl(''),
      controlRoName: new FormControl(''),


      controlGeography: new FormControl('', [Validators.required]),
      controlRegion: new FormControl('', [Validators.required]),
      controlContactName: new FormControl('', [Validators.required]),

      controlAddress: new FormControl('', [Validators.required]),
      controlLane: new FormControl(''),
      controlLandmark: new FormControl(''),
      controlArea: new FormControl(''),
      controlCity: new FormControl('', [Validators.required]),
      controlState: new FormControl('', [Validators.required]),
      controlZip: new FormControl('', [Validators.required,Validators.maxLength(6),Validators.minLength(6)]),


    });

    //  this.userFormGroup.get('myEmailField').setValidators(Validators.required)

  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  get f() {
    return this.userFormGroup.controls
  }


  profileChanged(value) {

    this.profiles.forEach(element => {
      if (element.id == value) {
        this.selectedProfile = element;
        console.log(this.selectedProfile);
        this.userFormGroup.reset({
          controlProfile: this.selectedProfile.id
        });
        // (this.selectedProfile.id<4)?(this.isAdminRole= true):(this.isAdminRole=false);
        if (this.selectedProfile.id == 4) {
          this.getUsersByRole(18);
          this.isTSE = true
          this.userFormGroup.get('controlDistributor').setValidators(Validators.required)

        }
        else {
          this.isTSE = false;
        }
        (this.selectedProfile.id == 19 ||this.selectedProfile.id == 14 ||this.selectedProfile.id == 15 )?this.isOthersUser = true :this.isOthersUser = false;

        if (this.selectedProfile.id == 5) {
          this.isOutlet = true;
          this.getUsersByRole(4);
          this.userFormGroup.get('controlTSE').setValidators(Validators.required)
          this.userFormGroup.get('controlChannel').setValidators(Validators.required)

        }
        else
          this.isOutlet = false;
        (this.selectedProfile.id == 18) ? this.isDistributor = true : this.isDistributor = false;

        if (this.selectedProfile.id == 5 || this.selectedProfile.id == 18)
          this.userFormGroup.get('controlLicense').setValidators(Validators.required)
      }
    });
  }

  geographyChanged(value) {
    this.geographeis.forEach(element => {
      if (element.id == value) {
        this.seletedGeograpghy = element;
        console.log(this.seletedGeograpghy);
      }
    });
  }

  channelChanged(value) {
    this.channels.forEach(element => {
      if (element.id == value) {
        this.seletedChannel = element;
        console.log(this.seletedChannel);
      }
    });
  }

  getUserDetails(id) {
    this.apiService.get(this.apiConfig.getUserById + id)
      .subscribe((res: any) => {
        this.user = res.data;
        console.log('user details')

        console.log(res.data)
        /////////////////setup user details//////////////////
        /////////////outlet////////////////
        if (this.user.user_data.user_role_id == 5) {
          this.isOutlet = true;
          this.isDistributor=false;
          this.isOthersUser=false;
          this.isTSE=false;
          this.userFormGroup.controls['controlProfile'].setValue(this.user.user_data.user_role_id)
          this.userFormGroup.controls['controlChannel'].setValue(this.user.channel_id)
          this.userFormGroup.controls['controlTSE'].setValue(this.user.user_data.supervisor)

          this.userFormGroup.controls['controlMgrName'].setValue(this.user.manager_name)
          this.userFormGroup.controls['controlMgrPhone'].setValue(this.user.manager_contact_no)
          this.userFormGroup.controls['controlPhone'].setValue(this.user.contact_no)
          this.userFormGroup.controls['controlEmail'].setValue(this.user.ro_email)
          this.userFormGroup.controls['controlLicense'].setValue(this.user.license_no)

          this.userFormGroup.controls['controlGeography'].setValue(this.user.geographical_id)
          this.userFormGroup.controls['controlContactName'].setValue(this.user.user_detail_name)
          this.userFormGroup.controls['controlRegion'].setValue(this.user.region_id)

          this.getUsersByRole(4);
          this.userFormGroup.get('controlTSE').setValidators(Validators.required)
          this.userFormGroup.get('controlChannel').setValidators(Validators.required)

        }
        if (this.user.user_data.user_role_id == 4) {

          this.getUsersByRole(18);
          this.isTSE = true
          this.isOutlet = false;
          this.isDistributor=false;
          this.isOthersUser=false;
          this.userFormGroup.get('controlDistributor').setValidators(Validators.required)
          this.userFormGroup.controls['controlProfile'].setValue(this.user.user_data.user_role_id)
          this.userFormGroup.controls['controlEmpCode'].setValue(this.user.emp_code)
          this.userFormGroup.controls['controlDistributor'].setValue(this.user.user_data.supervisor)

          this.userFormGroup.controls['controlPhone'].setValue(this.user.contact_no)
          this.userFormGroup.controls['controlEmail'].setValue(this.user.ro_email)

          this.userFormGroup.controls['controlGeography'].setValue(this.user.geographical_id)
          this.userFormGroup.controls['controlContactName'].setValue(this.user.user_detail_name)
          this.userFormGroup.controls['controlRegion'].setValue(this.user.region_id)

        }

        if (this.user.user_data.user_role_id == 18) {

          this.isTSE = false;
          this.isOutlet = false;
          this.isDistributor=true;
          this.isOthersUser=false;
          this.userFormGroup.get('controlDistributor').setValidators(Validators.required)
          this.userFormGroup.controls['controlProfile'].setValue(this.user.user_data.user_role_id)
          this.userFormGroup.controls['controlEmpCode'].setValue(this.user.emp_code)

          this.userFormGroup.controls['controlPhone'].setValue(this.user.contact_no)
          this.userFormGroup.controls['controlEmail'].setValue(this.user.ro_email)

          this.userFormGroup.controls['controlLicense'].setValue(this.user.license_no)

          this.userFormGroup.controls['controlGeography'].setValue(this.user.geographical_id)
          this.userFormGroup.controls['controlContactName'].setValue(this.user.user_detail_name)
          this.userFormGroup.controls['controlRegion'].setValue(this.user.region_id)

          this.userFormGroup.get('controlLicense').setValidators(Validators.required)

        }

        if (this.user.user_data.user_role_id == 19 ||this.user.user_data.user_role_id == 14 ||this.user.user_data.user_role_id == 15) {

          this.isTSE = false;
          this.isOutlet = false;
          this.isDistributor=false;
          this.isOthersUser=true;
          this.userFormGroup.controls['controlProfile'].setValue(this.user.user_data.user_role_id)
          this.userFormGroup.controls['controlEmpCode'].setValue(this.user.emp_code)

          this.userFormGroup.controls['controlPhone'].setValue(this.user.contact_no)
          this.userFormGroup.controls['controlEmail'].setValue(this.user.ro_email)


          this.userFormGroup.controls['controlGeography'].setValue(this.user.geographical_id)
          this.userFormGroup.controls['controlContactName'].setValue(this.user.user_detail_name)
          this.userFormGroup.controls['controlRegion'].setValue(this.user.region_id)


        }

        this.userFormGroup.controls['controlRoCode'].setValue(this.user.ro_code)
        this.userFormGroup.controls['controlRoName'].setValue(this.user.ro_name)


        /////////////////////Adress common//////////////////////

        this.userFormGroup.controls['controlAddress'].setValue(this.user.address)
        this.userFormGroup.controls['controlLane'].setValue(this.user.lane)
        this.userFormGroup.controls['controlLandmark'].setValue(this.user.landmark)
        this.userFormGroup.controls['controlArea'].setValue(this.user.area)
        this.userFormGroup.controls['controlCity'].setValue(this.user.city)
        this.userFormGroup.controls['controlState'].setValue(this.user.state_code)
        this.userFormGroup.controls['controlZip'].setValue(this.user.pincode)



        this.userFormGroup.get('controlRole').value;


      }, err => {
        console.log(err);
      })
  }

  getUserProfiles() {
    this.apiService.get(this.apiConfig.allProfiles)
      .subscribe((res: any) => {
        this.profiles = res.data;
        console.log(res.data)
      }, err => {
        console.log(err);
      })
  }

  getUsersByRole(roleId) {
    let postdata = {
      "filter_search_geography": [],
      "filter_search_channel": [],
      "filter_search_region": [],
      "filter_search_userrole": [roleId]
    };
    this.apiService.post(this.apiConfig.getUsersFilter, postdata)
      .subscribe((res: any) => {
        this.roleUserList = res.body.data;
        console.log(res.data)
      }, err => {
        console.log(err);
      })
  }


  getChannelTypes() {
    this.apiService.get(this.apiConfig.getAllChannel)
      .subscribe((res: any) => {
        this.channels = res.data.all_channels;
        console.log(res.data)
      }, err => {
        console.log(err);
      })
  }

  getGeographeis() {
    this.apiService.get(this.apiConfig.getAllGeographies)
      .subscribe((res: any) => {
        this.geographeis = res.data;
        console.log(res.data)
      }, err => {
        console.log(err);
      })
  }

  getRegions() {
    this.apiService.get(this.apiConfig.configGetRegion)
      .subscribe((res: any) => {
        this.regions = res.data.region;
        console.log(res.data)
      }, err => {
        console.log(err);
      })
  }

  getCitieAndStates() {
    this.apiService.get(this.apiConfig.configGetCities)
      .subscribe((res: any) => {
        this.cities = res.data.cities;
        this.states = res.data.state_list;

        console.log(res.data)
      }, err => {
        console.log(err);
      })
  }


  onSubmitUser() {

    this.submitted = true;

    console.log(this.userFormGroup)
    if (this.userFormGroup.invalid) {
      console.log("invalid form data  -- ")
      //this.showError('Error Message',"Please enter all required fields");
      return;
    }

    console.log("submitted form -- ")

    this.userFormGroup.get('controlProfile').value
    let postData = {
      "id":null,
      "user_id":null,
      channel_id:null,
      "geographical_id": null,
      "channel_type": null,
      "sub_channel": null,
      "state_code": null,
      "ro_code": null,
      "ro_name": null,
      "ro_email": null,
      "user_detail_name": null,
      "subbranch_id": null,
      "salestax_regno": null,
      "class_code": null,
      "group_id": null,
      "license_no": null,
      "outlet_img1": null,
      "outlet_img2": null,
      "profile_pic": null,
      "address": null,
      "lane": null,
      "landmark": null,
      "area": null,
      "city": null,
      "pincode": null,
      "contact_no": null,
      "business_from_time": null,
      "business_to_time": null,
      "cover_def": null,
      "chiller_placed": null,
      "signage_placed": null,
      "stock_space": null,
      "waiter_no": null,
      "owner_name": null,
      "owner_contact_no": null,
      "manager_name": null,
      "manager_contact_no": null,
      "manager_email": null,
      "location_id": null,
      "status": 1,
      "created_date": null,
      "updated_date": null,
      "tse_user_id": 0,
      "document_no": null,
      "document_file": null,
      "gender": null,
      "date_of_birth": null,
      "emp_code": "E001146",
      "latitude": null,
      "longitude": null,
      "anniversary_date": null,
      "region_id": null,
      "user_role_id": null,
      "program_id": 1,
      "username": null,
      "password_hash": null,
      "last_login_at": null,
      "last_login_ip": null,
      "status_label": "Active",
      "supervisor": 167,
      "is_verified": false,
      "points": 0,
      "default_lang": "en",
      "wallet": null,
      "generated_super": null
    }
    if (this.userFormGroup.get('controlProfile').value == 18) {
      console.log('Distributor json forming')
      postData.user_role_id = Number(this.userFormGroup.get('controlProfile').value);
      postData.geographical_id = Number(this.userFormGroup.get('controlGeography').value);
      postData.region_id = Number(this.userFormGroup.get('controlRegion').value);
      postData.contact_no = this.userFormGroup.get('controlPhone').value;
      postData.ro_email = this.userFormGroup.get('controlEmail').value;
      postData.emp_code = this.userFormGroup.get('controlEmpCode').value;
      postData.user_detail_name = this.userFormGroup.get('controlContactName').value;

      postData.license_no = this.userFormGroup.get('controlLicense').value;

      postData.address = this.userFormGroup.get('controlAddress').value;
      postData.lane = this.userFormGroup.get('controlLane').value;
      postData.landmark = this.userFormGroup.get('controlLandmark').value;
      postData.area = this.userFormGroup.get('controlArea').value;
      postData.city = this.userFormGroup.get('controlCity').value;
      postData.state_code = Number(this.userFormGroup.get('controlState').value);
      postData.pincode = this.userFormGroup.get('controlZip').value;

      postData.username = this.userFormGroup.get('controlPhone').value;
      postData.password_hash = this.userFormGroup.get('controlPhone').value;

    }

    if (this.userFormGroup.get('controlProfile').value == 19 || this.userFormGroup.get('controlProfile').value == 14 ||this.userFormGroup.get('controlProfile').value == 15) {
      console.log('Influencer json forming')
      postData.user_role_id = Number(this.userFormGroup.get('controlProfile').value);
      postData.geographical_id = Number(this.userFormGroup.get('controlGeography').value);
      postData.region_id = Number(this.userFormGroup.get('controlRegion').value);
      postData.contact_no = this.userFormGroup.get('controlPhone').value;
      postData.ro_email = this.userFormGroup.get('controlEmail').value;
      postData.emp_code = this.userFormGroup.get('controlEmpCode').value;
      postData.user_detail_name = this.userFormGroup.get('controlContactName').value;


    }

    if (this.userFormGroup.get('controlProfile').value == 4) {
      console.log('TSE json forming')
      postData.user_role_id = Number(this.userFormGroup.get('controlProfile').value);
      postData.emp_code = this.userFormGroup.get('controlEmpCode').value;
      postData.supervisor = this.userFormGroup.get('controlDistributor').value;

      postData.contact_no = this.userFormGroup.get('controlPhone').value;
      postData.ro_email = this.userFormGroup.get('controlEmail').value;
      postData.geographical_id = Number(this.userFormGroup.get('controlGeography').value);
      postData.region_id = Number(this.userFormGroup.get('controlRegion').value);
      postData.user_detail_name = this.userFormGroup.get('controlContactName').value;


      postData.user_role_id = Number(this.userFormGroup.get('controlProfile').value);
    }



    if (this.userFormGroup.get('controlProfile').value == 5) {
      console.log('OUTLET json forming')
      postData.user_role_id = Number(this.userFormGroup.get('controlProfile').value);
      postData.channel_id = this.userFormGroup.get('controlChannel').value;
      postData.supervisor = this.userFormGroup.get('controlTSE').value;
      postData.manager_name = this.userFormGroup.get('controlMgrName').value;
      postData.manager_contact_no = this.userFormGroup.get('controlMgrPhone').value;

      postData.contact_no = this.userFormGroup.get('controlPhone').value;
      postData.ro_email = this.userFormGroup.get('controlEmail').value;
      postData.license_no = this.userFormGroup.get('controlLicense').value;
      postData.geographical_id = Number(this.userFormGroup.get('controlGeography').value);
      postData.user_detail_name = this.userFormGroup.get('controlContactName').value;
      postData.region_id = Number(this.userFormGroup.get('controlRegion').value);



    }
    postData.id= this.user.id;
    postData.user_id= this.user.user_id;
    postData.ro_code = (this.userFormGroup.get('controlRoCode').value).toString();
    postData.ro_name = this.userFormGroup.get('controlRoName').value;
    postData.address = this.userFormGroup.get('controlAddress').value;
    postData.lane = this.userFormGroup.get('controlLane').value;
    postData.landmark = this.userFormGroup.get('controlLandmark').value;
    postData.area = this.userFormGroup.get('controlArea').value;
    postData.city = this.userFormGroup.get('controlCity').value;
    postData.state_code = Number(this.userFormGroup.get('controlState').value);
    postData.pincode = this.userFormGroup.get('controlZip').value;

    postData.username = this.userFormGroup.get('controlPhone').value;
    postData.password_hash = this.userFormGroup.get('controlPhone').value;


    console.log(postData)

    this.apiService.put(this.apiConfig.updateUserPost+this.user.id, postData)
      .subscribe((res: any) => {
        console.log(res)
        this.router.navigateByUrl('/hubAdmin/user-management/users')
      }, err => {
        this.toast.Error("Failed to Update");
        console.log(err);
      })
  }
}
